import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import type { StageCategory } from '@recruitee/stages-types';

@Injectable()
export class AnonymousCandidateAnalytics extends AnalyticsBase {
  public readonly namespace = 'AnonymousCandidates';
  public readonly requireViewContext = true;

  public trackStageStateChange(opts: { enabled: boolean; stageType: StageCategory }): void {
    this.track('StageStateChange', opts);
  }

  public trackChangeCompanySettings(enabled: boolean): void {
    this.track('ChangeCompanySettings', { mode: enabled ? 'display' : 'turnOFF' });
  }
}
